import { List } from "immutable";
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";
import * as redux from "redux";
import { EditForm } from "./EditForm";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import * as Forms from "../../../forms";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
    navItems: state.adminNavListState.navItems,
    pageFromList: ownProps && ownProps.match.params.id !== "0"
        ? state.adminPageListState.pages.find((p) => p !== undefined && p.id.toString() === ownProps.match.params.id)
        : undefined,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    goto: (url: string) => dispatch(push(url)),
    loadNavItems: () => dispatch(Actions.AdminNavList.loadData()),
    notifyError: (message: string, icon?: string) => dispatch(Actions.Noti.notifyError(message, icon)),
    notifySuccess: (message: string, icon?: string) => dispatch(Actions.Noti.notifySuccess(message, icon)),
});

interface RouteParams {
    id: string;
}

interface OwnProps extends RouteComponentProps<RouteParams> {
}

interface ConnectedState {
    api: Api;
    navItems: List<M.AdminNav.NavListItem>;
    pageFromList?: M.AdminPage.ListItem;
}

interface ConnectedDispatch {
    goto: (url: string) => void;
    loadNavItems: () => void;
    notifyError: (message: string, icon?: string) => void;
    notifySuccess: (message: string, icon?: string) => void;
}

interface OwnState {
    page?: M.Page.Page;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class EditComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    private _form: EditForm | null = null;

    public constructor(props: any) {
        super(props);
        this.state = {
            loading: this.props.match.params.id !== "0", // show loading if page id is given
        };
    }

    public componentWillMount() {
        // load navigation items only if none are available yet (like landing on page/refreshing)
        if (this.props.navItems.size === 0)
            this.props.loadNavItems();
    }

    public componentDidMount() {
        this._isMounted = true;

        this.checkRouteParams(this.props.match.params);
    }

    public componentDidUpdate() {
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const breadcrumb = [
            <Link to={Paths.Admin.Landing}>Admin</Link>,
            <Link to={Paths.AdminPage.List}>Pages</Link>,
        ];

        let title = this.props.match.params.id === "0"
            ? "Add new page"
            : `Edit page ${this.props.pageFromList ? this.props.pageFromList.title : ""}`;

        if (this.state.page)
            title = `Edit page ${this.state.page.title}`;

        return <Comp.Page.AdminPage breadcrumb={breadcrumb} title={title}>
            <div style={{ position: "relative" }}>
                <Comp.Generic.LoadingSpinner show={this.state.loading} />

                <EditForm
                    navItems={this.props.navItems}
                    onSubmit={(model, body) => this.onSubmit(model, body) }
                    ref={(ref) => this._form = ref }
                />
            </div>
        </Comp.Page.AdminPage>;
    }

    /**
     * Checks given route params and performs actions based on values
     * @param routeParams The url route params
     */
    private checkRouteParams(routeParams: RouteParams) {
        if (routeParams.id) {
            const pageId = parseInt(routeParams.id || "", 10);
            if (isNaN(pageId))
                this.props.notifyError(`Page ID ${routeParams.id} is invalid.`);
            else {
                // load data for edit
                this.loadPage(pageId);
            }
        }
        else {
            this.errorAndReturn("Invalid ID in URL");
        }
    }

    /**
     * Displays an error notification and returns to the admin nav list view
     * @param err The error message
     */
    private errorAndReturn(err: string) {
        this.props.notifyError(err);
        this.props.goto(Paths.AdminPage.List);
    }

    private async loadPage(pageId: number) {
        if (pageId > 0) {
            // edit
            this.toggleLoading(true);
            const qp = { queryParams: { id: pageId }};
            const result = await this.props.api.get<M.Page.Page>(Api.endpoints.admin.page.page, qp);

            if (!this._isMounted)
                return;

            if (result.isSuccess && result.data) {
                if (this._form)
                    this._form.setEditContext(result.data);

                this.setState({ ...this.state, page: result.data });
            }
            else
                this.errorAndReturn(result.errors.join("<br />"));

            this.toggleLoading(false);
        }
        else {
            // new
        }
    }

    private async onSubmit(model: Forms.AdminPage.PageEditData, body: any) {
        if (!this._form)
            return;

        // window.history.replaceState({ key: this.props.location.key, state: this.state });

        this._form.toggleProcessing(true);

        const result = await this.props.api.post<M.Page.Page>(Api.endpoints.admin.page.page, {
            body: JSON.stringify(body),
        });

        console.log(result);

        if (result.isSuccess) {
            this.props.notifySuccess(`Page <strong>${model.title}</strong> has been successfully saved.`);
            this.props.goto(Paths.AdminPage.List);
        }
        else if (this._form) {
            this._form.setFormErrors(M.Result.Result.errorsOrMessage(result), undefined, true);
        }

        if (this._form && this._isMounted)
            this._form.toggleProcessing(false);
    }

    /**
     * Optionally displays a success message and returns to the admin nav list view
     * @param msg Optional success message
     */
    // private successAndReturn(msg?: string) {
    //     if (msg)
    //         this.props.notifySuccess(msg);
    //     this.props.dispatchUrl(Paths.AdminPage.List);
    // }
}

export const Edit: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(EditComponent);



// WEBPACK FOOTER //
// ./src/containers/adminPage/edit/Edit.tsx